export const BANNER_FAIL = "BANNER_FAIL";
export const BANNER_SUCCESS = "BANNER_SUCCESS";
export const BANNER_REQUEST = "BANNER_REQUEST";